export const API_KEY = "BizOfficer123XYZ#$99";
export const API_URL = getAPIURL();

function getAPIURL(){
    let url;
    switch(window.location.host) {
      case 'tradeadmin.bizofficer.in':
        url = 'https://tradeapi.bizofficer.in';
        break;
      default:
        url = 'http://localhost:8097';
        ///url = 'https://api.repairwala.info';
    }
    return url;
}